(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-museum-collection"] && !Shopify.designMode) return;
  try {
    
  const catalogueForward = document.querySelector('[data-album-catalogue-url]');
  if (catalogueForward) {
    const target = new URL(catalogueForward.dataset.albumCatalogueUrl, location.origin);
    for (const [key, value] of new URLSearchParams(location.search)) {
      if (!['q', 'page', 'filter.p.product_type'].includes(key)) target.searchParams.append(key, value);
    }
    catalogueForward.querySelector('a').href = target.href;
    if (catalogueForward.dataset.redirectEnabled === 'true' && !window.Shopify?.designMode) location.replace(target.href);
  }

  if (!window.nadeltonCatalogueAudioBound) {
    window.nadeltonCatalogueAudioBound = true;
    document.addEventListener('play', event => {
      if (!event.target.matches?.('.his-catalogue-offer audio')) return;
      document.querySelectorAll('.his-catalogue-offer audio').forEach(audio => { if (audio !== event.target) audio.pause(); });
    }, true);
  }
  function initRecordLoading(root) {
    if (!root || root.dataset.loadingReady) return;
    const list = root.querySelector('[data-record-list]');
    const more = root.querySelector('[data-record-load-more]');
    const status = root.querySelector('[data-record-load-status]');
    if (!list || !more || !status || !window.fetch || !window.DOMParser) return;
    root.dataset.loadingReady = 'true';
    let busy = false;
    more.addEventListener('click', async (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (busy) return;
      const target = new URL(more.href, location.href);
      if (target.origin !== location.origin || target.pathname !== location.pathname) return;
      busy = true; more.setAttribute('aria-disabled', 'true'); list.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(target.href, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } });
        if (!response.ok) throw new Error('Page unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextRoot = page.querySelector('[data-record-catalogue]');
        const nextList = nextRoot?.querySelector('[data-record-list]');
        if (!nextList) throw new Error('Catalogue unavailable');
        const cards = [...nextList.children].filter(card => card.matches('.his-catalogue-offer') && !document.getElementById(card.getAttribute('aria-labelledby')));
        if (!cards.length) throw new Error('No new records');
        const fragment = document.createDocumentFragment();
        for (const card of cards) fragment.append(document.importNode(card, true));
        list.append(fragment);
        const next = nextRoot.querySelector('[data-record-load-more]');
        if (next) { more.href = new URL(next.getAttribute('href'), target.href).href; status.textContent = status.dataset.loaded; }
        else { more.hidden = true; status.textContent = status.dataset.complete; }
        const first = list.children[list.children.length - cards.length]?.querySelector('.his-catalogue-title a');
        first?.focus({ preventScroll: true });
      } catch (_) { status.textContent = status.dataset.error; root.dataset.loadingReady = 'fallback'; more.removeAttribute('aria-disabled'); more.replaceWith(more.cloneNode(true)); }
      finally { busy = false; more.removeAttribute('aria-disabled'); list.removeAttribute('aria-busy'); }
    });
  }
  document.querySelectorAll('[data-record-catalogue]').forEach(initRecordLoading);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-record-catalogue]').forEach(initRecordLoading));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-museum-product"] && !Shopify.designMode) return;
  try {
    
  function openMuseumNotes(hash) {
    if (!hash || (!hash.startsWith('#his-notes-') && !hash.startsWith('#his-record-details-') && !hash.startsWith('#music-wire-'))) return;
    const panel = document.getElementById(hash.slice(1));
    let details = panel?.matches('details') ? panel : panel?.closest('details') || panel?.querySelector('details');
    while (details) {
      details.open = true;
      details = details.parentElement?.closest('details');
    }
    if (hash.startsWith('#music-wire-')) panel?.scrollIntoView({block: 'start'});
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#his-notes-"], a[href^="#his-record-details-"], a[href^="#music-wire-"]');
    if (link) openMuseumNotes(link.hash);
  });
  window.addEventListener('hashchange', () => openMuseumNotes(location.hash));
  openMuseumNotes(location.hash);

  } catch(e) { console.error(e); }
})();
})();
